// 各种版本首屏页面
import isPrerendering from '@/shared/utils/isPrerendering';

import type { RouteConfig } from 'vue-router';
import HOME_V3_ROUTE_CONFIG from '@/pages/home/route';
import ACTIVITY_HOME_ROUTE_CONFIG from '@/pages/activity-home/route';
import { RouterH5Enum, RouterV2Enum } from '../router-names';

const _isPrerendering = isPrerendering();

export default (): RouteConfig[] => ([
  {
    path: RouterV2Enum.aliminiHome,
    name: RouterV2Enum.aliminiHome,
    component: () => import(/* webpackChunkName: "alimini-home" */'@/views_v2/home'),
    meta: {
      pageId: 'finance_alimini_home',
      title: '臻有钱',
      siblingPaths: [RouterV2Enum.myProfile],
      needLogin: !_isPrerendering,
      isShowH5Nav: true,
    },
    children: [
      {
        path: RouterV2Enum.qualityAliminiHome,
        name: RouterV2Enum.qualityAliminiHome,
        component: () => import(/* webpackChunkName: "alimini-quality-home" */'@/views_v2/home/alimini/alimini-quality-home'),
        meta: {
          pageId: 'finance_alimini_quality_home',
          title: '',
          siblingPaths: [RouterV2Enum.myProfile],
          needLogin: !_isPrerendering,
        },
      },

      {
        path: RouterV2Enum.taglessAliminiHome,
        name: RouterV2Enum.taglessAliminiHome,
        component: () => import(/* webpackChunkName: "alimini-tagless-home" */'@/views_v2/home/alimini/alimini-tagless-home'),
        meta: {
          pageId: 'finance_alimini_tagless_home',
          title: '臻有钱',
          siblingPaths: [RouterV2Enum.myProfile],
          needLogin: !_isPrerendering,
        },
      },

      {
        path: RouterV2Enum.aliApplyFaildHome,
        name: RouterV2Enum.aliApplyFaildHome,
        component: () => import(/* webpackChunkName: "alimini-failed-home" */'@/views_v2/home/alimini/alimini-failed-home'),
        meta: {
          pageId: 'finance_alimini_failed_home',
          title: '臻有钱',
          siblingPaths: [RouterV2Enum.myProfile],
          needLogin: !_isPrerendering,
        },
      },
    ],
  },
  {
    path: RouterV2Enum.home,
    name: RouterV2Enum.home,
    component: () => import(/* webpackChunkName: "home" */'@/views_v2/home'),
    meta: {
      pageId: 'finance_home',
      title: '臻有钱',
      desc: '首页',
      siblingPaths: [RouterV2Enum.myProfile],
      needLogin: !_isPrerendering,
      isShowH5Nav: true,
    },
    children: [
      {
        path: RouterV2Enum.qualityHomePage, // 品质首页
        name: RouterV2Enum.qualityHomePage,
        component: () => import(/* webpackChunkName: "app-quality-home" */'@/views_v2/home/app/app-quality-home'),
        meta: {
          pageId: 'finance_qualityHomePage',
          upgradePageId: 'finance_upgradeAPage',
          title: '',
          desc: '品质首页',
          siblingPaths: [RouterV2Enum.myProfile],
          needLogin: !_isPrerendering,
          isShowH5Nav: true,
          navBarCustomProps: {
            leftColor: '#fff',
            color: '#fff',
            background: 'transparent',
            useImage: true,
            isShowAndroidStatusBar: false,
            isDarkStatusBar: false,
          },
        },
      },
      {
        path: RouterV2Enum.taglessHome, // 无标签首页
        name: RouterV2Enum.taglessHome,
        component: () => import(/* webpackChunkName: "app-tagless-home" */'@/views_v2/home/app/app-tagless-home'),
        meta: {
          pageId: 'finance_taglessHome',
          title: '臻有钱',
          desc: '无标签首页',
          siblingPaths: [RouterV2Enum.myProfile],
          needLogin: !_isPrerendering,
          isShowH5Nav: true,
          navBarCustomProps: {
            leftColor: '#fff',
            color: '#fff',
            background: 'transparent',
            useImage: true,
            isShowAndroidStatusBar: false,
            isDarkStatusBar: false,
          },
        },
      },
    ],
  },
  {
    path: RouterV2Enum.myProfile,
    name: RouterV2Enum.myProfile,
    component: () => import(/* webpackChunkName: "my-profile" */'@/views_v2/my-profile'),
    meta: {
      pageId: '臻有钱_我的页',
      title: '我的',
      siblingPaths: [RouterV2Enum.home],
      isShowH5Nav: true,
      controlNav: true,
      navBarCustomProps: {
        background: 'transparent',
        isShowAndroidStatusBar: false,
        isDarkStatusBar: false,
      },
      /** 是否页面内部自己上报pageview 埋点 */
      ubtPageViewCustom: true,
    },
  },
  {
    path: RouterH5Enum.login,
    name: RouterH5Enum.login,
    component: () => import(
      /* webpackChunkName: "login" */ '@/viewsH5/login/login-phone'
    ),
    meta: {
      pageId: '臻有钱_登录页_手机号',
      title: '输入手机号',
      needLogin: false,
    },
  },
  HOME_V3_ROUTE_CONFIG,
  ACTIVITY_HOME_ROUTE_CONFIG,
]);
